module.exports = __webpack_public_path__ + "img/0-02-0a-b13baa4036a726b27f95321cc279f72a9c9abb94071c234b0ffb74d06007605c_cf9f79c7.6c08d867.jpg";